import beverages from './beverages.jpg'
import breakfast from './breakfast.jpg'
import main from './main.jpeg'
import outlay from './outlay.jpeg'
import logo from './logo.png'

let images = {
    beverages,
    breakfast,
    main,
    outlay,
    logo
}

export default images